<template>
<div class="mall-preference">
  <div class="preference-content">
    <h1>联创商城</h1>
    <p>由鸿联云精心挑选“质量可靠、服务优质、有口皆碑”的精品软件与服务</p>
    <div class="search-content">
      <a-select class="select-box"  style="width: 120px" v-model="searchType">
        <a-select-option v-for="(el,i) in typeList" :key="i" :value="el.value">
          {{el.text}}
        </a-select-option>
      </a-select>
      <a-input class="search-box" @pressEnter="search" size="large" v-model="code" placeholder="请搜索相关内容">
        <img @click="search" style="cursor: pointer" slot="suffix" src="@/assets/img/2.0/mall/search.png" alt="">
      </a-input>
    </div>

    <div class="list">
      <div class="list-title">鸿联优选 <img src="@/assets/img/2.0/mall/hot.png" alt=""></div>

      <swiper
          class="swiper list-box"
          :options="swiperOptionThumbs"
      >
        <swiper-slide
            v-for="el in replaceList"
            :key="el.id"
        >
          <div class="card" @click="replaceInfo(el)">
            <div class="card-img">
              <VImg :attachment-id="el.productCover"/>
            </div>
            <div class="content-card">
              <div>
                <div class="text-overflow">{{ el.productName }}</div>
                <p  class="text-overflow2" v-html="el.productBlurb"></p>
              </div>
              <div class="bottom">
                <div>￥{{el.productPrice}}</div>
                <div class="text-overflow">
                  <img src="@/assets/img/2.0/mall/company.png" alt="">
                  {{el.isvName}}
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>


    </div>
  </div>
</div>
</template>

<script>
import VImg from '@/components/VImg.vue'
import {getProductList} from '@/api/iot.js'
import {getDatNewProductList, getProducListByCondition, getProductReplaceList} from '@/api/dat.js'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "mallPreference",
  components: {SwiperSlide, Swiper,VImg},
  data(){
    return{
      code:'',
      searchType:'1',
      replaceList:[],
      typeList:[
        {text:'解决方案',value:'1'},
        {text:'服务',value:'2'},
        {text:'IoT硬件',value:'3'},
        {text:'应用',value:'4'},
        {text:'供应商',value:'5'},
      ],
      swiperOptionThumbs:{
        // loop: true,
        autoplay:true,
        slidesPerView : 5,
        slidesPerGroup : 5,
      }
    }
  },
  computed: {
  },
  methods:{
    loadGetIotProductList() {
      getProducListByCondition({}).then((res) => {
        this.replaceList = res;
      });
    },
    // 详情
    replaceInfo(item) {
      const {linkType}=item
      if(linkType==='new_product'){
        this.$router.push({
          path: "/replace/newInfo",
          query: { id:item.id },
        });
      }
      if(linkType==='service_market'){
        this.$router.push({
          path: "/service/details",
          query: { id:item.id },
        });
      }
    },
    search(){
      const {code,searchType}=this
      if(!code) return
      if(searchType==='1'){
        this.$router.push({name:'solution',params: {code}})
      }
      if(searchType==='2'){
        this.$router.push({name:'service',params: {code}})
      }
      if(searchType==='3'){
        this.$router.push({name:'replace',params: {code}})
      }
      if(searchType==='4'){
        this.$router.push({name:'market',params: {code}})
      }
      if(searchType==='5'){
        this.$router.push({name:'treasury',params: {code}})
      }
    },
  },
  mounted() {
    this.loadGetIotProductList()
  }
}
</script>


<style scoped lang="scss">
.mall-preference{
  width: 100%;
  height: 680px;
  background: url("../../../assets/img/2.0/mall/homeBg1.png") no-repeat;
  background-size: cover;
  .preference-content{
    width: 1280px;
    margin: 0 auto;
    padding: 56px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    >h1{
      font-weight: 600;
      font-size: 40px;
      color: #262626;
      line-height: 56px;
      margin-bottom: 16px;
    }
    >p{
      font-weight: 400;
      font-size: 16px;
      color: #262626;
      line-height: 22px;
    }
    .search-content{
      display: flex;
      margin-top: 24px;
      >.select-box{
        border-right:1px solid #E8E8E8;
        color: #323233;
        ::v-deep{
          .ant-select-selection--single{
            height: 56px;
            border: none;
          }
          .ant-select-selection__rendered{
            line-height: 56px;
          }
        }
      }
      >.search-box{
        width: 640px;
        ::v-deep{
          .ant-input{
            height: 56px;
            border: none;
            padding-right: 44px;
          }
          .ant-input-suffix{
            right: 24px;
          }
        }
      }
    }

    >.list{
      width: 1280px;
      margin-top: 26px;
      .list-title{
        font-weight: 400;
        font-size: 28px;
        color: #262626;
        line-height: 40px;
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        >img{
          margin-left: 8px;
        }
      }
      .list-box{
        .card{
          width: 236px;
          height: 312px;
          background: #FFFFFF;
          padding: 0 24px;
          display: flex;
          flex-direction: column;
          cursor: pointer;
          .card-img{
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px 0;
            >img{
              max-width: 100%;
              max-height: 100%;
            }
          }
          .content-card{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom: 24px;
            >:first-child{
              >div{
                font-weight: 400;
                font-size: 16px;
                color: #262626;
                line-height: 22px;
                margin-bottom: 8px;
              }
              >p{
                font-weight: 400;
                font-size: 12px;
                color: #8C8C8C;
                line-height: 16px;
              }
            }
            >.bottom{
              >:first-child{
                font-weight: 400;
                font-size: 18px;
                color: #EA0B06;
                line-height: 24px;
                margin-bottom: 10px;
              }
              >:last-child{
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                line-height: 16px;
                >img{
                  display: block;
                  width: 14px;
                  height: 14px;
                  margin-right: 8px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
